var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-circle-left",
    "data-name": "Icon awesome-arrow-circle-left",
    d: "M8.063,15.563a7.5,7.5,0,1,1,7.5-7.5A7.5,7.5,0,0,1,8.063,15.563Zm.874-4.343L6.653,9.03h5.522A.724.724,0,0,0,12.9,8.3V7.821a.724.724,0,0,0-.726-.726H6.653l2.283-2.19a.727.727,0,0,0,.012-1.037l-.333-.33a.723.723,0,0,0-1.025,0L3.578,7.548a.723.723,0,0,0,0,1.025l4.013,4.013a.723.723,0,0,0,1.025,0l.333-.33A.727.727,0,0,0,8.936,11.22Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#de6438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackOrangeArrow);
export default __webpack_public_path__ + "static/media/icon-back-orange-arrow.daf2d4ff7386ac5e653221982e93ffa5.svg";
export { ForwardRef as ReactComponent };